export default {
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  SPACE: 32,
};
